import React, { useEffect, useRef, useState } from 'react';
import { useSocket } from '../context/SocketContext';
import { formatTime } from '../utils/format';

export default function NotificationBell() {
  const { notifications, unread, markRead, markAllRead, connected } = useSocket();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onClick = (event) => {
      if (!wrapRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div className="bell" ref={wrapRef}>
      <button
        type="button"
        className="bell__button"
        onClick={() => setOpen((v) => !v)}
        aria-label={`اعلان‌ها${unread ? ` (${unread} خوانده‌نشده)` : ''}`}
        aria-expanded={open}
      >
        🔔
        {unread > 0 && <span className="bell__count num">{unread > 99 ? '99+' : unread}</span>}
        <span
          className={`bell__wire ${connected ? 'is-live' : 'is-offline'}`}
          title={connected ? 'اتصال بلادرنگ برقرار است' : 'اتصال بلادرنگ قطع است — تازه‌سازی دوره‌ای'}
        />
      </button>

      {open && (
        <div className="bell__panel">
          <div className="bell__panel-head">
            <strong>اعلان‌ها</strong>
            {notifications.length > 0 && (
              <button type="button" className="link" onClick={markAllRead}>
                خواندن همه
              </button>
            )}
          </div>

          {notifications.length === 0 ? (
            <p className="bell__empty">اعلان خوانده‌نشده‌ای ندارید.</p>
          ) : (
            <ul className="bell__list">
              {notifications.map((item, index) => (
                <li key={item.id ?? `live-${index}`}>
                  <button
                    type="button"
                    className="bell__item"
                    onClick={() => markRead(item.id)}
                    title="علامت زدن به‌عنوان خوانده‌شده"
                  >
                    <span className="bell__icon" aria-hidden="true">{item.icon || '📌'}</span>
                    <span className="bell__text">
                      {item.message}
                      <time>{formatTime(item.created_at)}</time>
                    </span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
